import React from "react";
import { Link } from "react-router";
import ContentContainer from "../../../common/content-container";
import AudioCard from "../../../common/audio-card";
import { useTranslation } from "react-i18next";

const SermonCollections = (props) => {
  const { t } = useTranslation();
  return (
    <div className="container text-justify text-relevant">
      <h1>{t("audio-sermon-collections")}</h1>
      <p>
        {t("audio-mzbc")}
        <a href="https://mtzionbiblechurch.org/sermons" target="_blank">
          MtZionBibleChurch.org
        </a>
      </p>
      <div className="container text-relevant">
        <h3>Spurgeon</h3>
        <p>{t("audio-spurgeon")}</p>
      </div>

      <ContentContainer
        get={props.getCharlesSpurgeonAudios}
        content={(data, i) => (
          <AudioCard key={data.id} audio={data}></AudioCard>
        )}
      />

      <div className="container text-relevant">
        <h3>Here we stand</h3>
        <p>{t("audio-here-we-stand")}</p>
      </div>
      <ContentContainer
        get={props.getHereWeStand}
        content={(data, i) => (
          <AudioCard key={data.id} audio={data}></AudioCard>
        )}
      />

      <div className="container text-relevant">
        <h3>Lectures in Pastoral Theology</h3>
      </div>
      <ContentContainer
        get={props.getPastoralTheology}
        content={(data, i) => (
          <AudioCard key={data.id} audio={data}></AudioCard>
        )}
      />

      <div className="container text-relevant">
        <h3>{t("conferences")}</h3>
      </div>
      <ContentContainer
        get={props.getConferences}
        content={(data, i) => (
          <AudioCard key={data.id} audio={data}></AudioCard>
        )}
      />

      <div className="container text-relevant">
        <h3>Lee Roy Shelton, Jr.</h3>

        <p>
          {t("audio-leeroy-shelton")}
          <Link to={"/author/sheltonjrleeroy"}> {t("know-more")}...</Link>
        </p>
        <p
          dangerouslySetInnerHTML={{
            __html: t("audio-leeroy-shelton-sponsor"),
          }}
        ></p>
      </div>
      <ContentContainer
        get={props.getLeeRoyShelton}
        content={(data, i) => (
          <AudioCard key={data.id} audio={data}></AudioCard>
        )}
      />
    </div>
  );
};

export default SermonCollections;
